import { BuddyPageAdminUsers } from '@adornis/bh-matching-user/components/buddy-page-admin-users.js';
import { GeneratedFormDialog } from '@adornis/cms/client/generated-form-dialog.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { customElement } from 'lit/decorators.js';
import { registerMentoringAdminUser } from '../../api/user.js';
import { BaseUser } from '@adornis/users/db/a-user.js';

@customElement('mentoring-page-admin-users')
export class MentoringPageAdminUsers extends BuddyPageAdminUsers {
  override async _registerAdminUser() {
    const user = await GeneratedFormDialog.edit(new BaseUser({}));
    if (!user) return;
    void XDialog.guard(() => registerMentoringAdminUser(user)());
  }
}
